import React from "react";
import { consola } from "consola";

import firebase from "firebase/compat/app";
import "firebase/compat/firestore";

// export type OrganizationDataProps = {
//   uid,
// };

const useOrganizationSubscription = ({ uid }) => {
  const [organizationData, setOrganizationData] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);
  const subscribeRef = React.useRef();

  React.useEffect(() => {
    if (!uid) {
      setLoading(false);
      return;
    }

    const getData = async () => {
      try {
        setLoading(true);
        setError(null);
        const userRef = firebase.firestore().collection("users").doc(uid);
        consola.debug("++++++ READ -> useOrganizationSubscription: getData")
        const userData = await userRef.get();
        if (userData.exists) {
          const userDataValues = userData.data();

          if (!userDataValues || !userDataValues.organizationId) {
            setLoading(false);
            setError("No organization found for user");
            return;
          }

          const ref = firebase
            .firestore()
            .collection("organizations")
            .doc(userDataValues.organizationId);

          // Get initial data first to avoid blank page while waiting for snapshot
          try {
            const initialDoc = await ref.get();
            if (initialDoc.exists) {
              setOrganizationData(initialDoc.data());
              setLoading(false);
              consola.debug("++++++ READ -> useOrganizationSubscription: initial data loaded");
            } else {
              setError("Organization not found");
              setOrganizationData(null);
              setLoading(false);
            }
          } catch (initialError) {
            consola.error("Error loading initial organization data:", initialError);
            // Continue to set up listener even if initial load fails
          }

          // Set up real-time listener for updates
          subscribeRef.current = ref.onSnapshot(
            (doc) => {
              consola.debug("++++++ SNAPSHOT -> useOrganizationSubscription: getData")
              // Don't set loading to false here - it's already set from initial load
              if (doc.exists) {
                setOrganizationData(doc.data());
              } else {
                setError("Organization not found");
                setOrganizationData(null);
              }
            },
            (err) => {
              consola.error("Error in organization subscription:", err);
              setError(err.message);
              setLoading(false);
            }
          );
        } else {
          setLoading(false);
          setError("User not found");
        }
      } catch (err) {
        consola.error("Error fetching organization data:", err);
        setError(err.message);
        setLoading(false);
      }
    };

    getData();

    return () => {
      if (subscribeRef.current) {
        subscribeRef.current();
      }
    };
  }, [uid]);

  return { organizationData, loading, error };
};

export default useOrganizationSubscription;
